const ALLOWED_EXTENSIONS = [
    // images
    { extension: 'jpg', mime_type: 'image/jpeg' },
    { extension: 'jpeg', mime_type: 'image/jpeg' },
    { extension: 'png', mime_type: 'image/png' },
    { extension: 'gif', mime_type: 'image/gif' },
    { extension: 'webp', mime_type: 'image/webp' },
    { extension: 'svg', mime_type: 'image/svg+xml' },
    //  documents
    { extension: 'pdf', mime_type: 'application/pdf' },
    { extension: 'doc', mime_type: 'application/msword' },
    { extension: 'docx', mime_type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
    // Spreadsheets
    { extension: 'xls', mime_type: 'application/vnd.ms-excel' },
    { extension: 'xlsx', mime_type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
    { extension: 'ods', mime_type: 'application/vnd.oasis.opendocument.spreadsheet' },
    // dicom
    { extension: 'dcm', mime_type: 'application/dicom' },
    { extension: 'dcm', mime_type: 'image/dicom' },
]
export default ALLOWED_EXTENSIONS;